/* eslint-disable @department-of-veterans-affairs/prefer-button-component */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLoginModal } from 'platform/site-wide/user-nav/actions';
import { isLoggedIn } from 'platform/user/selectors';

const SponsorSignInAlert = () => {
  const loggedIn = useSelector(isLoggedIn);
  const dispatch = useDispatch();
  return (
    !loggedIn && (
      <va-alert status="warning" slim>
        <p className="vads-u-margin-top--0">
          If you’re the Veteran completing this form on behalf of your
          dependents, signing in first can prefill some of your information,
          including eligibility information.
        </p>
        <button
          type="button"
          className="va-button-link"
          onClick={() => dispatch(toggleLoginModal(true))}
        >
          Sign in to start your application
        </button>
      </va-alert>
    )
  );
};

export default SponsorSignInAlert;
